module.exports = __webpack_public_path__ + "media/images/svg/jobs/calendar-with-a-clock-time-tools-9af6c4826cb6e4ec84d45d2743825057.svg";